<template>
<div class="question-answer-wrapper">

  <el-page-header @back="onBack" content="专家问答" class="head" />

    <!-- 分页导航 -->
    <el-row class = "tool">
      <el-col :span="10" class="pager">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :page-sizes="[10,20,30,40]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="page.totalRecord">
        </el-pagination>
      </el-col>
      <el-col :span="4" class="question-button">
        <el-button round size="small" icon="el-icon-edit" @click="onQuestion">提问</el-button>
      </el-col>
    </el-row>
  
  <el-card class="question-list">
    <el-card v-for="item in datas" :key="item.id" class="question-item">
      <div class="title">{{item.questionTitle}}</div>
      <div class="question-user">
        <el-avatar class="question-avatar" :size="30" :src="item.questionUserAvatar" />
        <span class="question-name-time">
          <div class="question-name">{{item.questionUserName}}</div>
          <div class="question-time">{{item.questionTime}}</div>  
        </span>
      </div>
      <div class="content">{{item.questionContent}}</div>
      
      <div v-if="item.answer!=null" class="answer-user">
        <el-avatar class="answer-avatar" :size="30" :src="item.answerUserAvatar" />
        <span class="answer-name-time">
          <div class="answer-name">{{item.answerUserName}}</div>
          <div class="answer-time">{{item.answerTime}}</div>
        </span>
      </div>
      <div class="answer">{{item.answer}}</div>

    </el-card>
  </el-card>

  <el-dialog
    title="提问"
    :visible.sync="dialogVisible"
    width="40%"
    :before-close="handleClose">
    <el-form ref="form" class = "question-form" :model="form" label-width="50px">
      <el-form-item label="标题"
        :rules="[
          { required: true, message: '请输入标题', trigger: 'blur' },
        ]"
      >
        <el-input v-model="form.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="内容"
        :rules="[
          { required: true, message: '请输入内容', trigger: 'blur' },
        ]"
      >
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" 
          placeholder="请输入内容"
          v-model="form.content">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>

</div>
</template>

<script type="text/ecmascript-6">
import {mapState} from 'vuex'

export default {
  name: 'Questionanswer',
  data () {
    return {
      dialogVisible: false,
      page: {
        pageSize: 10, //每页条数,  默认100条
        totalRecord: 0, //总条数
        totalPage: 0, //总页数
        currentPage:1  //当前显示页码
      },
      datas:[],
      form:{
        title:'',
        content: ''
      }
    }
  },
  computed: {
    // 将vuex中的全局变量userinfo、colleges映射为组件的局部变量
    ...mapState({
      userinfo: 'userinfo',
    }),
  },
  mounted(){
    this.loadData()
  },
  methods: {
    handleClose(done) {
      const that = this
      this.$confirm('确认关闭？')
        .then(() => {
          done();
          that.form.title=''
          that.form.content=''
        })
        .catch(() => {});
    },
    loadData(){
      const that = this
      let params = {
        'currentpage': that.page.currentPage,
        'pagesize': that.page.pageSize
      }
      that.axios.get('/homepage/questionanswer/listbypage', {params})
      .then((ret)=>{
        let {code,message,data} = ret
        if(code===0){
          that.datas = data.list;
          that.page.totalRecord = data.total  //总条数
          that.page.totalPage = data.pages    //总页数
        }else{
          that.$message('查询失败')
          that.$message(message)
        }
      })
    },
    onQuestion(){
      this.dialogVisible = true
    },
    onSubmit(){
      const that = this
      const params = new FormData()
      params.append('title', that.form.title)
      params.append('content', that.form.content)
      params.append('questionuserid', that.userinfo.id)
      that.axios.post('/homepage/questionanswer/save', params)
      .then((ret)=>{
        let {code,message} = ret
        if(code===0){
          that.$message('提交成功')
          that.loadData()
          that.form.title=''
          that.form.content=''
          this.dialogVisible = false
        }else{
          that.$message('提交失败')
          that.$message(message)
        }
      })
    },
    onBack(){
      this.$router.back()
    },
    // 修改每页记录数
    sizeChange(val) {
      this.page.pageSize = val
      this.loadData()
    },
    //翻页
    currentChange(val) {
      this.page.currentPage=val
      this.loadData()
    },
  }
}
</script>

<style lang="stylus" scoped>
.question-answer-wrapper
  margin-left :50px
  margin-right: 50px
  .head
    height: 100px  
    >>> .el-page-header__title
      line-height: 100px
    >>> .el-page-header__content
      line-height: 100px
  .tool
    margin: 10px
    height: 50px
    display: flex
    align-items: center
    .question-button
      margin-left: 10px
  .question-list
    .question-item
      .title
        font-weight: bold
      .question-user
        margin: 10px 0px 10px 0px
        display:flex
        align-items: center
        .question-name-time
          margin-left: 5px
          .question-name
            font-size: 15px
          .question-time
            font-size: 10px
      .answer-user
        margin: 10px 0px 10px 0px
        display:flex
        align-items: center
        .answer-name-time
          margin-left: 5px
          .answer-name
            font-size: 15px
          .answer-time
            font-size: 10px
</style>
